import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Entry {
  id: string;
  organization: string;
  phone: string;
  note: string;
  sort_order: number;
}

const empty = { organization: '', phone: '', note: '', sort_order: 0 };

export default function PhoneDirectoryPage() {
  const [items, setItems] = useState<Entry[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState<any>(empty);
  const [editId, setEditId] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/admin/phone-directory')
      .then(res => setItems(res?.items || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const openNew = () => { setEditId(null); setForm(empty); setShowForm(true); };
  const openEdit = (e: Entry) => {
    setEditId(e.id);
    setForm({ organization: e.organization, phone: e.phone, note: e.note, sort_order: e.sort_order });
    setShowForm(true);
  };

  const handleSubmit = async (ev: React.FormEvent) => {
    ev.preventDefault();
    if (!form.organization.trim()) return;
    setSaving(true);
    try {
      if (editId) await api.put(`/admin/phone-directory/${editId}`, form);
      else await api.post('/admin/phone-directory', form);
      setShowForm(false); setForm(empty); setEditId(null);
      load();
    } catch (err: any) {
      alert(err?.body ? JSON.parse(err.body)?.detail || 'Алдаа' : 'Алдаа гарлаа');
    } finally { setSaving(false); }
  };

  const handleDelete = async (e: Entry) => {
    if (!window.confirm(`"${e.organization}"-г устгах уу?`)) return;
    await api.delete(`/admin/phone-directory/${e.id}`);
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22', margin: 0 }}>Хэрэгцээт дугаар</h2>
          <p style={{ color: '#5f6f66', fontSize: 13, margin: '4px 0 0' }}>Оршин суугчдад зориулсан хэрэгцээт байгууллага, үйлчилгээний утасны жагсаалт</p>
        </div>
        <button onClick={openNew} style={btnPrimary}>+ Дугаар нэмэх</button>
      </div>

      {loading ? <p>Уншиж байна...</p> : (
        <div style={card}>
          {items.length === 0 ? (
            <p style={{ color: '#5f6f66', textAlign: 'center', padding: 24 }}>Одоогоор дугаар нэмээгүй байна.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                  <th style={th}>Байгууллага / үйлчилгээ</th>
                  <th style={th}>Утас</th>
                  <th style={th}>Тэмдэглэл</th>
                  <th style={th}></th>
                </tr>
              </thead>
              <tbody>
                {items.map(e => (
                  <tr key={e.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                    <td style={td}><strong>{e.organization}</strong></td>
                    <td style={td}>{e.phone || '-'}</td>
                    <td style={{ ...td, color: '#5f6f66' }}>{e.note || '-'}</td>
                    <td style={td}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => openEdit(e)} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', fontSize: 13 }}>Засах</button>
                        <button onClick={() => handleDelete(e)} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 13 }}>Устгах</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowForm(false)}>
          <div style={{ ...card, width: 480, maxWidth: '90%' }} onClick={ev => ev.stopPropagation()}>
            <h3 style={{ margin: '0 0 16px', fontWeight: 700, color: '#1c2b22' }}>{editId ? 'Дугаар засах' : 'Шинэ дугаар'}</h3>
            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 14 }}>
              <div>
                <label style={labelStyle}>Байгууллага / үйлчилгээ *</label>
                <input value={form.organization} onChange={e => setForm({ ...form, organization: e.target.value })} style={inputStyle} placeholder="Онцгой байдлын алба" required />
              </div>
              <div>
                <label style={labelStyle}>Утас</label>
                <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} style={inputStyle} placeholder="105" />
              </div>
              <div>
                <label style={labelStyle}>Тэмдэглэл</label>
                <input value={form.note} onChange={e => setForm({ ...form, note: e.target.value })} style={inputStyle} placeholder="24 цагийн" />
              </div>
              <div>
                <label style={labelStyle}>Эрэмбэ (жижиг нь дээр)</label>
                <input type="number" value={form.sort_order} onChange={e => setForm({ ...form, sort_order: Number(e.target.value) })} style={inputStyle} />
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                <button type="submit" disabled={saving} style={{ ...btnPrimary, opacity: saving ? 0.7 : 1 }}>{saving ? 'Хадгалж байна...' : 'Хадгалах'}</button>
                <button type="button" onClick={() => setShowForm(false)} style={{ background: '#e8e5dc', color: '#2a3b32', border: 'none', padding: '8px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>Болих</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const btnPrimary: React.CSSProperties = { background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'" };
const card: React.CSSProperties = { background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 16 };
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = { width: '100%', padding: '10px 14px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6' };
